"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const colors_1 = require("../constants/colors");
const styled_components_1 = __importDefault(require("styled-components"));
const colorVariant = {
    white: {
        color: colors_1.colors.whiteBase,
        bg: colors_1.colors.greyBase
    },
    grey: {
        color: colors_1.colors.greyBase,
        bg: "transparent"
    },
    "light-grey": {
        color: colors_1.colors.greyLighten40,
        bg: colors_1.colors.silverLighten70
    },
    "lighten-grey": {
        color: colors_1.colors.greyLighten70,
        bg: "transparent"
    },
    pink: {
        color: colors_1.colors.pinkBase,
        bg: colors_1.colors.pinkLighten80
    },
    "pink-white": {
        color: colors_1.colors.pinkBase,
        bg: colors_1.colors.whiteBase
    },
    green: {
        color: colors_1.colors.greenBase,
        bg: colors_1.colors.greenLighten80
    },
    "green-white": {
        color: colors_1.colors.greenBase,
        bg: colors_1.colors.whiteBase
    },
    silver: {
        color: colors_1.colors.whiteBase,
        bg: colors_1.colors.silverBase
    },
    yellow: {
        color: colors_1.colors.yellowBase,
        bg: "transparent"
    },
    "light-silver": {
        color: colors_1.colors.silverLighten40,
        bg: colors_1.colors.whiteBase
    },
    blue: {
        color: colors_1.colors.blueBase,
        bg: "transparent"
    },
    "blue-white": {
        color: colors_1.colors.blueBase,
        bg: colors_1.colors.whiteBase
    },
    "lightGrey-transparent": {
        color: "#8a94a2",
        bg: "transparent"
    },
    "silver-transparent": {
        color: colors_1.colors.silverBase,
        bg: "transparent"
    }
};
const setColorsVariant = (variant = "grey") => {
    const { bg, color } = colorVariant[variant];
    return `background-color: ${bg}; color: ${color};`;
};
exports.Icon = styled_components_1.default.div `
  align-items: center;
  border-radius: ${(props) => props.theme.utils.radius};
  display: inline-flex;
  justify-content: center;

  ${(props) => setColorsVariant(props.color)};
`;
//# sourceMappingURL=icon.js.map